import React from 'react';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay } from '@tapresearch/ui/components';
import { Accordion } from '@chakra-ui/react';
import { useGetQualificationsWithAnswers } from '../../../../api/QualificationAPI';
import { MultipleSkeletonLoader } from '../../../common/MultipleSkeletonLoader';
import { FilterAccordionItem } from '../../../common/Filter/FilterAccordionItem';
import { QualificationSelector } from './QualificationSelector';
export function LongitudinalFilterDrawer(param) {
    var _param_isOpen = param.isOpen, isOpen = _param_isOpen === void 0 ? false : _param_isOpen, countryId = param.countryId, languageId = param.languageId, _param_onClose = param.onClose, onClose = _param_onClose === void 0 ? function() {
    //
    } : _param_onClose;
    var _useGetQualificationsWithAnswers = useGetQualificationsWithAnswers(countryId, languageId), data = _useGetQualificationsWithAnswers.data, isLoading = _useGetQualificationsWithAnswers.isLoading;
    return /*#__PURE__*/ React.createElement(Drawer, {
        size: "md",
        isOpen: isOpen,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(DrawerOverlay, null), /*#__PURE__*/ React.createElement(DrawerContent, null, /*#__PURE__*/ React.createElement(DrawerHeader, {
        paddingY: "8",
        paddingX: "6"
    }, "Data filters"), /*#__PURE__*/ React.createElement(DrawerBody, {
        padding: "0",
        "data-testid": "longitudinal-filter-drawer-body"
    }, isLoading && /*#__PURE__*/ React.createElement(MultipleSkeletonLoader, {
        numItems: 6
    }), !isLoading && /*#__PURE__*/ React.createElement(Accordion, {
        allowMultiple: true
    }, data.map(function(qualification) {
        return /*#__PURE__*/ React.createElement(FilterAccordionItem, {
            filterName: qualification.id,
            key: qualification.id,
            title: qualification.attributes.name
        }, /*#__PURE__*/ React.createElement(QualificationSelector, {
            qualification: qualification
        }));
    })))));
}
